//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'tundra1',
    colors: ['#40708c', '#8e998c', '#5d3f37', '#ed6954', '#f2e9e2'],
    type: 'tundra',
  },
  {
    name: 'tundra2',
    colors: ['#5f9e93', '#3d3638', '#733632', '#b66239', '#b0a1a4', '#e3dad2'],
    type: 'tundra',
  },
  {
    name: 'tundra3',
    colors: ['#87c3ca', '#7b7377', '#b2475d', '#7d3e3e', '#eb7f64', '#d9c67a', '#f3f2f2'],
    type: 'tundra',
  },
  {
    name: 'tundra4',
    colors: ['#d53939', '#b6754d', '#a88d5f', '#524643', '#3c5a53', '#7d8c7c', '#dad6cd'],
    type: 'tundra',
  },
];
